import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthServiceZ } from './../../authentification/auth-service.service';
import { TranslateService } from '@ngx-translate/core';
import { PushNotificationService } from './../push-notification.service';
import { SharedService } from './../shared.service';
import { environment } from './../../../environments/environment';

declare var $;
@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
  notifications = [];
  user;
  business;
  appVersion = environment.api.appVersion;
  constructor(
    private authenticationService: AuthServiceZ,
    private router: Router,
    public translate: TranslateService,
    public notifServ: PushNotificationService,
    public sharedService: SharedService
  ) {
    translate.addLangs(['en', 'fr']);

    if (localStorage && localStorage.getItem('locale')) {
      const browserLang = localStorage.getItem('locale');
      translate.use(browserLang.match(/en|fr/) ? browserLang : 'fr');
      translate.setDefaultLang('fr');
    } else {
      localStorage.setItem('locale', 'fr');
      translate.setDefaultLang('fr');
    }
  }

  ngOnInit(): void {
    if (this.sharedService.user) {
      this.sharedService.getMyProfileNow().then((d) => {
        this.sharedService
          .getBusinessByUserId(this.sharedService.user)
          .then((d) => {
            this.business = d;
          });
      });
    }
  }

  changeLang(language: string) {
    localStorage.setItem('locale', language);
    this.translate.use(language);
  }

  logout() {
    localStorage.clear();
    // this.router.navigate(['/auth/login/admin']);
    console.log('zzzzzz');

    location.reload();
  }

  onScroll() {}
  searchForParcel(item) {
    if (this.authenticationService?.credentials?.user?.userType == 'User') {
      this.router.navigate(['/business/livraison'], {
        queryParams: { keyword: item.jobRequest.nid },
      });
    }
  }
}
